import { render, staticRenderFns } from "./criterium.vue?vue&type=template&id=7bdfb626&scoped=true&"
import script from "./criterium.vue?vue&type=script&lang=js&"
export * from "./criterium.vue?vue&type=script&lang=js&"
import style0 from "./criterium.vue?vue&type=style&index=0&id=7bdfb626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfb626",
  null
  
)

export default component.exports